import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { hoyChile, primerDiaMesChile } from '../../services/utils';

const ReporteRanking = () => {
    const hoy = hoyChile();
    const primerDiaMes = primerDiaMesChile();

    const [ranking, setRanking] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtros, setFiltros] = useState({ inicio: primerDiaMes, fin: hoy });

    // 🚨 FUNCIÓN PARA LIMPIAR LA CANTIDAD: Si es entero, lo deja entero. Si es decimal, 1 dígito.
    const formCant = (cant) => {
        const num = Number(cant);
        return num % 1 === 0 ? num : num.toFixed(1);
    };

    const cargarRanking = async () => {
        setLoading(true);
        try {
            const token  = localStorage.getItem("token");
            const url = `${config.api_url}/api/reportes/ranking?inicio=${filtros.inicio}&fin=${filtros.fin}`;
            const res = await fetch(url, {
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    'token': token 
                }
            });

            const json = await res.json();
            if (json.status === 'success') {
                setRanking(json.ranking || []);
            }
        } catch (e) { 
            console.error("Error al cargar ranking:", e); 
        } finally { 
            setLoading(false); 
        }
    };

    useEffect(() => {
        cargarRanking();
    }, []);

    // Evita división por cero
    const totalMaximo = ranking.length > 0 ? Number(ranking[0].total_vendido) : 1;

    return (
        <div className="card shadow-sm border-0 rounded-lg p-4">
            <h4 className="font-weight-bold mb-4">
                <i className="fas fa-trophy text-warning mr-2"></i> Top 20 Productos
            </h4>
            
            <div className="row mb-4">
                <div className="col-md-5"><input type="date" className="form-control" value={filtros.inicio} onChange={e => setFiltros({...filtros, inicio: e.target.value})} /></div>
                <div className="col-md-5"><input type="date" className="form-control" value={filtros.fin} onChange={e => setFiltros({...filtros, fin: e.target.value})} /></div>
                <div className="col-md-2"><button className="btn btn-dark btn-block" onClick={cargarRanking}>OK</button></div>
            </div>

            {loading ? (
                <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x"></i></div>
            ) : ranking.length === 0 ? (
                <div className="text-center py-5 text-muted">No hay datos en este rango.</div>
            ) : (
                ranking.map((p, i) => (
                    <div key={i} className="mb-3">
                        <div className="d-flex justify-content-between mb-1">
                            <span className="font-weight-bold">
                                {i < 3 ? ['🥇', '🥈', '🥉'][i] : `${i + 1}.`} {p.producto}
                            </span>
                            {/* 🚩 AQUI ESTA LA MAGIA DEL FORMATEO */}
                            <span className="badge badge-primary">{formCant(p.total_vendido)} unid.</span>
                        </div>
                        <div className="progress" style={{ height: '8px', borderRadius: '4px' }}>
                            <div className={`progress-bar ${i < 3 ? 'bg-warning' : 'bg-info'}`} 
                                 style={{ width: `${(Number(p.total_vendido) / totalMaximo) * 100}%` }}
                                 title={`${formCant(p.total_vendido)} unidades`}>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};
export default ReporteRanking;